export enum ScoringMethod {
    RELATIVE_TIME_TO_FIRST = 1,
    POSITION_BASED = 2
}

export enum GroupScoringType {
    BY_CATEGORIZATION = 1,                // Po kategoriji utrka
    OVERALL_CATEGORIZATION = 2,                    // Ukupno (sve kategorije zajedno)
    BY_CATEGORIZATION_SEPARATE_GENDERS = 3,  // Po kategoriji utrka, muške i ženske ekipe
    OVERALL_CATEGORIZATION_SEPARATE_GENDERS = 4        // Ukupno (sve kategorije zajedno), muške i ženske ekipe
}

export enum RankingMethod {
    OVERALL = 1,
    BY_GENDER = 2,
    BY_CATEGORY = 3,
}

export enum AttendanceBonusType {
    NOT_USED = 1,
    FIXED_ATTENDANCE_BONUS_POINTS = 2,
    VARIABLE_ATTENDANCE_BONUS_POINTS = 3,
}